// import React from 'react';
// import { Wrench, Phone } from 'lucide-react';
// import './Footer.css';

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-container">
//         <div className="footer-content">
//           <div className="footer-brand">
//             <Wrench className="footer-icon" />
//             <span className="footer-brand-text">ACGPL</span>
//           </div>
//           <p className="footer-tagline">
//             Looking for durable, affordable, and compatible spare parts?
//           </p>
//           <div className="footer-contact">
//             <Phone className="contact-icon" />
//             <span>Call us today</span>
//           </div>
//         </div>
//         <div className="footer-bottom">
//           <p>&copy; 2025 ACGPL. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;








import React from 'react';
import { Wrench, Phone, MapPin, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <Wrench className="footer-icon" />
            <span className="footer-brand-text">Megapix Machinery Private Limited
</span>
          </div>
          <p className="footer-tagline">
            Looking for durable, affordable, and compatible spare parts?
          </p>
          <div className="footer-contact-info">
            <div className="contact-item">
              <MapPin className="contact-icon" />
              <div className="contact-details">
                <h4 className="contact-title">📍 Office Address</h4>
                <p className="contact-text">
                   Jessore Road, <br/> Khudiram Colony,<br />
                   Kolkata, West Bengal,<br />
                   700074, India
                </p>
              </div>
            </div>
            
            <div className="contact-item">
              <Phone className="contact-icon" />
              <div className="contact-details">
                <h4 className="contact-title">📞 Phone</h4>
                <p className="contact-text">
                  +91-9330566254<br />
                  <span className="contact-hours">(Mon–Sat, 9:00 AM – 7:00 PM)</span>
                </p>
              </div>
            </div>
            
            <div className="contact-item">
              <Mail className="contact-icon" />
              <div className="contact-details">
                <h4 className="contact-title">📧 Email</h4>
                <p className="contact-text">info@megapixmachinery.co.in</p>
              </div>
            </div>
          </div>
          
          {/* <div className="footer-cta">
            <Phone className="cta-icon" />
            <span>Call us today</span>
          </div> */}
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Megapix Machinery Private Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;





